import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import callAPI from "utils/api";

export const initialState = {
	visitId: null,
	traffic_source_id: null,
	siteId: 424,
	user_ip: null,
	// The real browser UA, forwarded to ssapigw as client-user-agent so its
	// Optimizely decisions can pass $opt_user_agent for bot filtering.
	userAgent: null,
	// Flower Mound, TX fallback when Cloudflare geo headers are missing or non-US.
	// Mirrors FALLBACK_LOCATION in server/lib/middleware/geolocation.js (full
	// region name, string lat/long), minus regionCode, which no client consumer
	// reads. isFallback is forwarded to the gateway as x-geo-is-fallback.
	geolocation: {
		city: "Flower Mound",
		region: "Texas",
		country: "US",
		latitude: "33.0342",
		longitude: "-97.1139",
		isFallback: true
	},
	// "fallback" = cloudflare couldn't resolve, using Flower Mound TX default
	// "ip" = derived from Cloudflare headers (city-level precision)
	// "browser" = user granted navigator.geolocation (GPS precision)
	geolocationSource: "fallback"
};

/**
 * Save multiple meta entries in a single request (batch insert).
 * @param {Array<{key: string, value: string}>} entries - Array of meta entries
 */
export const saveBatchMeta = createAsyncThunk(
	"user/saveBatchMeta",
	async ({ entries }, { getState }) => {
		const { app, user } = getState();

		const headers = {
			token: app.apiToken,
			"Content-Type": "application/json",
			"app-id": app.id,
			"site-id": user.siteId,
			"visit-id": user.visitId,
			"traffic-source-id": user.traffic_source_id,
			"x-is-bot":
				user.visitId === "bot" || user.visitId === "error" ? 1 : 0,
			"x-sparefoot-ip": user.user_ip
		};

		const response = await callAPI({
			url: `${app.apiHost}/api/visit/meta`,
			options: {
				headers,
				method: "POST",
				body: {
					meta: entries
				}
			}
		});

		return { response };
	}
);

export const userSlice = createSlice({
	name: "user",
	initialState,
	reducers: {
		setGeolocation: (state, action) => {
			// isFallback is derived, never read from the payload: it and
			// geolocationSource encode the same fact for different consumers
			// (buildGeoHeaders vs the UI), so deriving is what stops them
			// disagreeing. render.js derives the other direction on the SSR seed.
			state.geolocation = {
				...action.payload.geolocation,
				isFallback: action.payload.source === "fallback"
			};
			state.geolocationSource = action.payload.source;
		}
	}
});

export const { setGeolocation } = userSlice.actions;

export default userSlice.reducer;
